export default __webpack_public_path__ + "static/media/icon-telegram.3dd28e32.svg";